import React, { useRef } from 'react';
import nextId from 'react-id-generator';

type CommentSelectPaneProps = {
  onChange: () => void,
  selected: boolean,
  disabled: boolean
}

const CommentSelectPane: React.FC<CommentSelectPaneProps> = ({ selected, onChange, disabled }) => {
  const inputId = useRef(nextId());

  return (
    <div className="panel-footer text-right">
      <label htmlFor={inputId.current} className="bottom-buffer-none-lg">
        <input
          id={inputId.current}
          className="comment-select-pane-input"
          type="checkbox"
          checked={selected}
          onChange={onChange}
          disabled={disabled}
        />
        <span className="sr-only">Select comment for bulk operation</span>
      </label>
    </div>
  );
};

export default CommentSelectPane;
